/**
 * ⓘ — 화면에서 상시 읽을 필요는 없지만 **지워서는 안 되는** 단서.
 *
 * 증거 화면에서 숫자·표기의 뜻을 사람이 추측하게 두면 안 된다. 그렇다고
 * 모든 단서를 문단으로 늘어놓으면 정작 핵심이 묻힌다(운영자 2026-09-06:
 * "쓸데없는 말이 많아. 핵심만 간결하게"). 그래서 **규칙은 상시 표시, 단서는
 * 여기**로 나눈다.
 *
 * 표기는 `RoMSHBadge` 가 쓰는 것과 같다 — 네이티브 `title` 툴팁 + `aria-label`.
 * 새 상호작용을 만들지 않으므로 키보드·스크린리더에서도 그대로 읽힌다.
 */
export default function InfoDot({ note }: { note: string }) {
  return (
    <span
      role="img"
      aria-label={note}
      title={note}
      className="cursor-help opacity-50"
    >
      ⓘ
    </span>
  );
}
